import { useEffect, useState } from "react"
import { niceDelay } from "./numbers"

type Options = {
  delay: "short" | "long" | number
  instantOnFalsy?: boolean
}

export default <TValue>(
  value: TValue,
  { delay, instantOnFalsy = false }: Options,
): TValue => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(
      () => {
        setDebouncedValue(value)
      },
      instantOnFalsy && !value ? 0 : niceDelay(delay),
    )

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay, instantOnFalsy])

  return debouncedValue
}
